// extracted by mini-css-extract-plugin
export default {"wrapper":"UserTabs_wrapper__Wejpk","tabs-wrapper":"UserTabs_tabs-wrapper__vHuUE","tab":"UserTabs_tab__fS5Oc","tab-active":"UserTabs_tab-active__zL-cj"};